import React from "react";

const HandoverDetailsModal = ({ open, handoverDetail, userInfo, onClose }) => {
  if (!open || !handoverDetail) return null;

  const formatDate = (dateString) => {
    if (!dateString) return "-";
    const date = new Date(dateString);
    return date.toLocaleDateString('en-GB', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric'
    });
  };

  return (
    <>
      <div className="modal fade show d-block" tabIndex="-1" role="dialog" aria-modal="true">
        <div className="modal-dialog modal-dialog-centered modal-lg" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Handover Details</h5>
              <button type="button" className="btn-close" aria-label="Close" onClick={onClose} />
            </div>
            <div className="modal-body">
              <div className="row">
                <div className="col-md-6">
                  <h6 className="text-muted mb-3">User Information</h6>
                  <div className="mb-3">
                    <div className="text-muted" style={{fontFamily:"Lato",fontWeight:400,fontSize:"14px",lineHeight:"150%", color:"#6B7280"}}>Name</div>
                    <div style={{fontFamily:"Lato",fontWeight:500,fontSize:"16px",lineHeight:"150%", color:"#2D3747"}}>
                      {userInfo?.first_name} {userInfo?.middle_name} {userInfo?.last_name}
                    </div>
                  </div>
                  <div className="mb-3">
                    <div className="text-muted" style={{fontFamily:"Lato",fontWeight:400,fontSize:"14px",lineHeight:"150%", color:"#6B7280"}}>Email</div>
                    <div style={{fontFamily:"Lato",fontWeight:400,fontSize:"14px",lineHeight:"150%", color:"#2D3747"}}>{userInfo?.email_id || "-"}</div>
                  </div>
                  <div className="mb-3">
                    <div className="text-muted" style={{fontFamily:"Lato",fontWeight:400,fontSize:"14px",lineHeight:"150%", color:"#6B7280"}}>Phone</div>
                    <div style={{fontFamily:"Lato",fontWeight:400,fontSize:"14px",lineHeight:"150%", color:"#2D3747"}}>{userInfo?.mobile_number || "-"}</div>
                  </div>
                  <div className="mb-3">
                    <div className="text-muted" style={{fontFamily:"Lato",fontWeight:400,fontSize:"14px",lineHeight:"150%", color:"#6B7280"}}>ID Number</div>
                    <div style={{fontFamily:"Lato",fontWeight:400,fontSize:"14px",lineHeight:"150%", color:"#2D3747"}}>{userInfo?.id_proof_number || "-"}</div>
                  </div>
                  <div className="mb-3">
                    <div className="text-muted" style={{fontFamily:"Lato",fontWeight:400,fontSize:"14px",lineHeight:"150%", color:"#6B7280"}}>User Type</div>
                    <div style={{fontFamily:"Lato",fontWeight:400,fontSize:"14px",lineHeight:"150%", color:"#2D3747"}}>{userInfo?.category_name || "-"}</div>
                  </div>
                  <div className="mb-3">
                    <div className="text-muted" style={{fontFamily:"Lato",fontWeight:400,fontSize:"14px",lineHeight:"150%", color:"#6B7280"}}>Organization</div>
                    <div style={{fontFamily:"Lato",fontWeight:400,fontSize:"14px",lineHeight:"150%", color:"#2D3747"}}>{userInfo?.organisation || "-"}</div>
                  </div>
                </div>
                <div className="col-md-6">
                  <h6 className="text-muted mb-3">Handover Information</h6>
                  <div className="mb-3">
                    <div className="text-muted" style={{fontFamily:"Lato",fontWeight:400,fontSize:"14px",lineHeight:"150%", color:"#6B7280"}}>Handed Over To (Receiver's Name)</div>
                    <div style={{fontFamily:"Lato",fontWeight:500,fontSize:"16px",lineHeight:"150%", color:"#2D3747"}}>{handoverDetail.poc_name || "-"}</div>
                  </div>
                  <div className="mb-3">
                    <div className="text-muted" style={{fontFamily:"Lato",fontWeight:400,fontSize:"14px",lineHeight:"150%", color:"#6B7280"}}>Receiver's Contact</div>
                    <div style={{fontFamily:"Lato",fontWeight:400,fontSize:"14px",lineHeight:"150%", color:"#2D3747"}}>{handoverDetail.poc_contact || "-"}</div>
                  </div>
                  <div className="mb-3">
                    <div className="text-muted" style={{fontFamily:"Lato",fontWeight:400,fontSize:"14px",lineHeight:"150%", color:"#6B7280"}}>Issued By</div>
                    <div style={{fontFamily:"Lato",fontWeight:400,fontSize:"14px",lineHeight:"150%", color:"#2D3747"}}>{handoverDetail.issued_by_name || "-"}</div>
                  </div>
                  <div className="mb-3">
                    <div className="text-muted" style={{fontFamily:"Lato",fontWeight:400,fontSize:"14px",lineHeight:"150%", color:"#6B7280"}}>Handover ID</div>
                    <div style={{fontFamily:"Lato",fontWeight:400,fontSize:"14px",lineHeight:"150%", color:"#2D3747"}}>{handoverDetail.id || "-"}</div>
                  </div>
                </div>
              </div>
              <div className="text-center mt-4">
                <button
                  className="btn btn-primary"
                  onClick={onClose}
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="modal-backdrop fade show" />
    </>
  );
};

export default HandoverDetailsModal;
